import Header from "@/components/Header";

const TerminosCondiciones = () => (
  <>
    <Header />
    <main className="min-h-screen bg-slate-50 px-4 py-24">
      <section className="mx-auto max-w-3xl rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
        <h1 className="text-2xl font-black text-slate-950">
          Terminos y condiciones
        </h1>
        <p className="mt-3 text-sm leading-6 text-slate-600">
          Al usar Tulocalmx aceptas utilizar la plataforma de forma responsable,
          proporcionar informacion verdadera y mantener actualizados los datos de
          tus publicaciones.
        </p>

        <div className="mt-6 space-y-5 text-sm leading-6 text-slate-600">
          <section>
            <h2 className="font-black text-slate-950">Uso de la plataforma</h2>
            <p>
              Tulocalmx permite buscar, registrar y administrar propiedades,
              locales, bodegas, terrenos, oficinas y otros espacios comerciales.
              Las publicaciones pueden ser revisadas, pausadas o rechazadas si
              contienen informacion falsa, incompleta, duplicada o contraria al
              funcionamiento de la plataforma.
            </p>
          </section>

          <section>
            <h2 className="font-black text-slate-950">Responsabilidad del usuario</h2>
            <p>
              Cada usuario es responsable de la informacion, imagenes, videos,
              precios, ubicaciones y datos de contacto que registre. El usuario
              declara tener autorizacion para publicar la propiedad o gestionar
              la informacion enviada.
            </p>
          </section>

          <section>
            <h2 className="font-black text-slate-950">Publicaciones</h2>
            <p>
              Tulocalmx puede mostrar, ordenar, revisar o retirar publicaciones
              para mejorar la calidad del servicio, proteger a los usuarios y
              evitar contenido confuso o engañoso.
            </p>
          </section>

          <section>
            <h2 className="font-black text-slate-950">Cambios</h2>
            <p>
              Estos terminos pueden actualizarse para reflejar mejoras del
              servicio, cambios legales o nuevas funciones de la plataforma.
            </p>
          </section>
        </div>
      </section>
    </main>
  </>
);

export default TerminosCondiciones;
